import '@hotwired/turbo-rails';
import { initializeDatadogRum } from '../javascript/config/datadog-rum';

import '../javascript/components/shared/analytics/kustomer-chat';
import '../javascript/components/auth/password-toggle';
import '../javascript/components/show-toast';
import '../javascript/components/wallet-passes/pass-download';
import { FormValidationComponent } from '../javascript/components/shared/validation/form-validation';

initializeDatadogRum();

const components = [FormValidationComponent];

export default components;
